import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Avatar, Input } from '@atomic';

const PostCommentInputContainer = styled.div`
  display: grid;
  grid-template-columns: 35px 1fr;
  gap: 8px;
`;

const PostCommentInput = ({ image, ...props }) => {
  return (
    <PostCommentInputContainer {...props}>
      <Avatar avatarUrl={image} borderSize={35} />
      <Input
        inputType="comment"
        name="commentInput"
        type="text"
        textSize={12}
        placeholder="댓글쓰기"
      />
    </PostCommentInputContainer>
  );
};

PostCommentInput.propTypes = {
  image: PropTypes.string,
};

export default PostCommentInput;
